// extracted by mini-css-extract-plugin
export default {"container":"JumplinksInline_container__U3N93","link":"JumplinksInline_link__bZgmz"};